import styled from 'styled-components';

const BodyContainer = styled.div`
  max-width: 1057px;
  margin: auto;
  margin-top: 38px;
  padding-left: 12px;
  padding-right: 12px;
  padding-bottom: 49px;
`;

const BottomButtonsContainer = styled.div`
  display: flex;
  margin-top: 49px;
  justify-content: flex-end;
  align-items: center;
`;

export default {
  BodyContainer,
  BottomButtonsContainer,
};
